/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import ReactTooltip from "react-tooltip";
import { Grid } from "@material-ui/core";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";

import { Wrapper, Popup } from "./styles";
import { paletas } from "../../../../../styles/theme";
import { useApp } from "../../../../../contexts";
import { Botao, Divisor, BotaoCadeado } from "../../../../../componentes";
import { appNivelSelecionado } from "../../../../../slices/app";
import { UpdateSistema } from "../../../../../servicos";
import { TipoAlgoritmoEnum } from "../../../../../enums";

type Props = {
  onIniciar: () => void;
  setTipoAlgoritmo: any;
  tipoAlgoritmo: number | undefined;
};

export default function IntroducaoTreino({
  onIniciar,
  setTipoAlgoritmo,
  tipoAlgoritmo,
}: Props) {
  const { usuario, setUsuarioCorrente } = useApp();
  let updateUsuario = usuario;
  const listaTipoAlgoritmo = ["Cálculos", "Condicionais", "Repetições"];
  const listaNivelAlgoritmo = ["Fácil", "Médio", "Difícil"];
  const [exibirMensagem, setExibirMensagem] = React.useState(
    updateUsuario.system.tutorial_begin
  );

  const dispatch = useDispatch();
  const { nivelSelecionado } = useSelector(
    (state: RootStateOrAny) => state.appSystem
  );

  const selecionarTipo = (num: number) => {
    setTipoAlgoritmo(num);
  };

  const selecionarNivel = (num: number) => {
    dispatch(appNivelSelecionado(num));
  };

  const fecharModalTreinamento = () => {
    updateUsuario.system.tutorial_begin = false;
    setUsuarioCorrente(updateUsuario);
    setExibirMensagem(false);
    try {
      if (navigator.onLine) {
        const dadosUpdate = { email: usuario.email, novoValor: usuario.system };
        UpdateSistema(dadosUpdate);
      } else {
        console.info("É necessário conexão com a internet!");
      }
    } finally {
    }
  };

  const checarLevel = (idx: number) => {
    if (TipoAlgoritmoEnum.CALCULOS === idx)
      return usuario.player_statistics.experience >= 0;
    if (TipoAlgoritmoEnum.CONDICIONAIS === idx)
      return usuario.player_statistics.experience >= 100;
    if (TipoAlgoritmoEnum.REPETICOES === idx)
      return usuario.player_statistics.experience >= 200;
  };

  return (
    <Wrapper>
      {exibirMensagem && (
        <Popup>
          <h4>Dev, seja bem vindo ao Modo de Treinamento</h4>
          <p>
            Treine suas habilidades nessa modalidade e fique preparado para
            enfrentar outros devs nos demais modos de jogo.
          </p>
          <h5>
            Leia e resolva o pseudocódigo escrito em{" "}
            <a
              href="https://pt.wikipedia.org/wiki/Portugol"
              target="_blanck"
              rel="noreferrer noopener"
            >
              Portugol
            </a>
            !
          </h5>
          <button
            aria-label="Fechar modal"
            onClick={() => fecharModalTreinamento()}
          >
            Fechar e não exibir de novo
          </button>
        </Popup>
      )}
      <Grid
        item
        xs={12}
        className={`headerInterno ${exibirMensagem && "blur"}`}
      >
        <h3>
          Treinamento
          <Divisor color={paletas.DarkOrange} />
        </h3>

        <h4>Selecione o tipo de algoritmo:</h4>
        <Grid container spacing={2} justify="center">
          {listaTipoAlgoritmo.map((item, idx) => {
            return (
              <Grid item xs={4} key={idx}>
                <div
                  data-tip
                  data-for={!checarLevel(idx) ? item : null}
                  data-iscapture="true"
                  className={`botoes ${idx === tipoAlgoritmo ? "ativo" : ""}  ${
                    false ? "disabled" : ""
                  }`}
                >
                  <BotaoCadeado
                    ariaLabel={`Algoritmo ${item}`}
                    onClick={() => selecionarTipo(idx)}
                    disabled={!checarLevel(idx)}
                    value={item}
                  />
                </div>
                {idx !== 0 ? (
                  <ReactTooltip id={item} type="dark" place="bottom">
                    {`Habilita no level ${idx + 1}`}
                  </ReactTooltip>
                ) : null}
              </Grid>
            );
          })}
        </Grid>
        <h4>Selecione o nível do algoritmo:</h4>
        <Grid container spacing={2} justify="center">
          {listaNivelAlgoritmo.map((item, idx) => {
            return (
              <Grid item xs={4} key={idx}>
                <div
                  className={`botoes ${
                    idx === nivelSelecionado ? "ativo" : ""
                  }`}
                >
                  <BotaoCadeado
                    ariaLabel={`Nível ${item}`}
                    onClick={() => selecionarNivel(idx)}
                    disabled={false}
                    value={item}
                  />
                </div>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={2}
        className={`botaoIniciar ${exibirMensagem && "blur"}`}
      >
        <Botao
          type="button"
          value="INICIAR TREINO"
          size="22px"
          color={paletas.Grafite75}
          background={paletas.DarkOrange}
          border={paletas.DarkOrange}
          disabled={false}
          onClick={onIniciar}
        />
      </Grid>
    </Wrapper>
  );
}
